var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tpf-mf-setting-textarea"},[_c('el-form',{attrs:{"label-position":"right","label-width":"85px","size":"small","model":_vm.model}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }